import { render, staticRenderFns } from "./turrezervasyonkisiler.vue?vue&type=template&id=86bf1a5a&scoped=true&"
import script from "./turrezervasyonkisiler.vue?vue&type=script&lang=js&"
export * from "./turrezervasyonkisiler.vue?vue&type=script&lang=js&"
import style0 from "./turrezervasyonkisiler.vue?vue&type=style&index=0&id=86bf1a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bf1a5a",
  null
  
)

export default component.exports